import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { verifyTripAccess } from '../lib/api';
import { setTripAccess } from '../lib/tripAccess';

export default function ScoringPinGate() {
  const { code, roundId } = useParams();
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!pin.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await verifyTripAccess(code, pin.trim());
      const role = res.data?.role;
      if (role) {
        setTripAccess(code, pin.trim(), role);
        navigate(`/trip/${code}/round/${roundId}/scoring`, { replace: true });
      } else {
        setError('Invalid organiser code or player code');
      }
    } catch (e) {
      const detail = e.response?.data?.detail || '';
      if (detail === 'invalid_credentials') {
        setError('Incorrect. Please try again.');
      } else {
        setError('Verification failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div className="min-h-screen bg-[#F4F6F5] flex items-center justify-center p-4" data-testid="scoring-pin-gate">
      <div className="bg-white rounded-2xl p-6 w-full max-w-xs shadow-sm border border-[#E1E6E4] text-center space-y-4">
        <h2 className="text-xl font-bold text-[#1D242B]">Enter Organiser Code or Player Code</h2>
        <p className="text-sm text-[#455561]">Enter your organiser code or player code to access this event.</p>
        <input
          type="password"
          inputMode="numeric"
          value={pin}
          onChange={(e) => { setPin(e.target.value); setError(''); }}
          onKeyDown={handleKeyDown}
          placeholder="Organiser code or player code"
          className="w-full h-14 text-center text-2xl font-bold tracking-widest rounded-xl border border-[#E1E6E4] focus:ring-2 focus:ring-[#1B4332] outline-none"
          autoFocus
          data-testid="scoring-pin-input"
        />
        {error && <p className="text-sm text-[#D32F2F] font-semibold" data-testid="scoring-pin-error">{error}</p>}
        <button
          onClick={handleSubmit}
          disabled={loading || !pin.trim()}
          className="w-full h-12 bg-[#1B4332] text-white font-bold rounded-xl hover:bg-[#163B2B] disabled:opacity-40 transition-colors"
          data-testid="scoring-pin-submit"
        >
          {loading ? 'Verifying...' : 'Continue'}
        </button>
      </div>
    </div>
  );
}
